import * as React from 'react'
import Info from "../../data/data";
import {Link} from "gatsby";

const ContactBox = () => {
    return (
        <div>
            <h2 className="bb-primary pb-2 mb-3 d-inline-block">Dane kontaktowe</h2>
            <p className="mb-0"><span><i className="bi-person pe-3 fs-4"></i></span><span>{Info.expert}</span></p>
            <p><span><i className="bi-person invisible pe-3 fs-4"></i></span><span>{Info.expert2}</span></p>
            <p className="mb-0">
                <Link to="/kontakt">
                    <span><i className="bi-geo-alt pe-3 fs-4"></i></span>
                    <span>{Info.addressPart0}</span>
                </Link>
            </p>
            <p className="mb-0">
                <Link to="/kontakt">
                    <span><i className="bi-geo-alt invisible pe-3 fs-4"></i></span>
                    <span>{Info.addressPart1}</span>
                </Link>
            </p>
            <p>
                <Link to="/kontakt">
                    <span><i className="bi-geo-alt invisible pe-3 fs-4"></i></span>
                    <span>{Info.addressPart2}</span>
                </Link>
            </p>
            <p>

                <a href={Info.phoneHref}>
                    <span><i className="bi-telephone pe-3 fs-4"></i></span>
                </a>
                <a className="btn btn-secondary btn-lg" href={Info.phoneHref} role="button">{Info.phone}</a>
            </p>
            <p>
                <span><i className="bi-envelope pe-3 fs-4"></i></span><span>{Info.email}</span>
            </p>
            <p>
                <a href={Info.facebookHref}>
                    <span><i className="bi-facebook pe-3 fs-4"></i></span><span>Dołącz do nas na Facebooku</span>
                </a>
            </p>
            <p>
                <a href={Info.instagramHref}>
                    <span><i className="bi-instagram pe-3 fs-4"></i></span><span>Obserwuj nasz Instagram</span>
                </a>
            </p>
        </div>
    )
}
export default ContactBox